<template>
  <div>
    <div style="height: 100%" v-if="loadingPage">
      <loader size="xxs" :loader-image="false" />
    </div>
    <div v-else class="w-full h-full">
      <div class="w-full flex justify-between items-center gap-5 mt-8">
        <div class="w-full">
          <div class="text-sm text-jet">
            Pay Group
          </div>
          <div class="h-10 mt-2 capitalize" :class="'disabled'">
            {{ paySettingsName ? paySettingsName : 'Autoloaded' }}
          </div>
        </div>
        <div class="w-full">
          <div class="text-sm text-jet">Pay Type</div>
          <div class="h-10 mt-2 capitalize" :class="'disabled'">
            {{ payType ? payType : '' }}
          </div>
        </div>
        <div class="w-full">
          <div class="text-sm text-jet">Pay Frequency</div>
          <div class="h-10 mt-2 capitalize" :class="'disabled'">
            {{ payFrequency ? payFrequency : '' }}
          </div>
        </div>
      </div>

      <div class="w-full mt-8 mb-8">
        <p class="font-black text-xs text-jet mb-5 uppercase">Statutory Deductions</p>
        <div v-if="isBasic || (!isBasic && employmentType !== 'Independent Contractor')"
          class="w-full flex justify-start items-center gap-6 text-jet font-normal text-base"
        >
          <div class="flex gap-1 justify-start items-center">
            <SwitchToggle class="m-top  opacity-50" :value="enabledPAYE" />
            <p>PAYE</p>
          </div>
          <div class="flex gap-1 justify-start items-center">
            <SwitchToggle class="m-top  opacity-50" :value="enabledPension"/>
            <p>Pension</p>
          </div>
          <div v-if="enabledNHF" class="flex gap-2 justify-start items-center">
            <div class="flex gap-1 justify-start items-center">
              <SwitchToggle class="m-top" :value="enabledNHF"
                @input="changeNhfNhisStatutory('nhf')"
              />
              <p>NHF</p>
            </div>
            <div @mouseenter="onEnter('nhf')" @mouseleave="onLeave('nhf')">
              <Icon
                icon-name="red-warning-icon"
                size="xs" class="cursor-pointer"
              />
              <ToolTip v-if="IsNHFToolTip" style="width: 298px !important" left="610px">
                <p class="tooltip__header text-white mb-1">NHF tool tip</p>
                <p class="w-full text-xs text-white text-left">
                  NHF is a voluntary housing fund contribution that your employer has enabled by default.
                  You may choose to opt out if you prefer not to participate.
                </p>
              </ToolTip>
            </div>
          </div>
          <div v-if="enabledNhis" class="flex gap-2 justify-start items-center">
            <div class="flex gap-1 justify-start items-center">
              <SwitchToggle class="m-top" :value="enabledNhis"
                @input="changeNhfNhisStatutory('nhis')"
              />
              <p>NHIS</p>
            </div>
            <div @mouseenter="onEnter('nhis')" @mouseleave="onLeave('nhis')">
              <Icon
                icon-name="red-warning-icon"
                size="xs" class="cursor-pointer"
              />
              <ToolTip v-if="IsNHISToolTip" style="width: 298px !important" left="742px">
                <p class="tooltip__header text-white mb-1">NHIS tool tip</p>
                <p class="w-full text-xs text-white text-left">
                  NHIS is a voluntary health insurance contribution that your employer has enabled by default.
                  You may choose to opt out if you prefer not to participate.
                </p>
              </ToolTip>
            </div>
          </div>
        </div>
        <div v-if="!isBasic && employmentType === 'Independent Contractor'"
          class="w-full flex justify-start items-center gap-6 text-jet font-normal text-base"
        >
          <div class="flex gap-1 justify-start items-center">
            <SwitchToggle class="m-top  opacity-50" :value="enabledWHT" />
            <p>WHT</p>
          </div>
        </div>
      </div>
      <accordionPaySetTables title="Earnings"
        :pay-settings-data="employeeEarnings"
      />
      <!-- <accordionPaySetTables v-if="employmentType !== 'Independent Contractor'"
        title="Deductions"
        :pay-settings-data="employeeDeductions"
      /> -->
      <other-benefits v-if="isBasic || (!isBasic && employmentType !== 'Independent Contractor')"
        :other-benefit-data="otherBenefitData"
      />
      <employeeReliefs v-if="isBasic || (!isBasic && employmentType !== 'Independent Contractor')"
        title="Reliefs"
        :employee-reliefs="employeeReliefs"
        :employee-reliefs-history="employeeReliefsHistorys"
        :employee-details="employeeDetails"
        :is-Loading="isLoadingReliefs"
        @refresh="refresh($event)"
      />
      <div class="line" v-if="isBasic || (!isBasic && employmentType !== 'Independent Contractor')"></div>
      <div v-if="isBasic || (!isBasic && employmentType !== 'Independent Contractor')" 
        class="w-full h-16 flex justify-start items-center gap-4"
      >
        <Button
          class="text-white rounded-xl bg-dynamicBackBtn h-11 flex justify-center items-center"
          :class="isBasic ? 'w-40' : 'w-28'"
          @click="savePaySettingChanges"
          :disabled="isSaving"
        >
          {{ isBasic ? 'Save Changes' : 'Save' }}
        </Button>
        <Button
          class="text-darkPurple bg-white h-11 flex justify-center items-center"
          :class="isBasic ? 'w-48' : 'w-28'"
        >
          {{ isBasic ? 'Revert Changes' : 'Cancel' }}
        </Button>
      </div>
      <Modal v-if="isNfhNhisModal">
        <Card class="flex p-4 flex-col max-w-md"
            style="min-width: 411px; max-height: 213px; overflow-y: auto"
        >
          <div class="w-full mb-5 text-sm text-jet font-normal">
            <p>
              {{ authText }}
            </p>
            <p class="mt-5">
              Are you sure you want to continue?
            </p>
          </div>
          <div class="w-full flex justify-end items-center gap-2">
            <button
              class="text-dynamicBackBtn rounded-lg font-semibold w-24 h-9 text-sm flex justify-center items-center border border-dynamicBackBtn"
              @click="optOutNhfNhis(false)"
            >
            Cancel
          </button>
          <button
              class="text-white rounded-lg font-semibold bg-dynamicBackBtn w-24 h-9 text-sm flex justify-center items-center outline-none border-none"
              @click="optOutNhfNhis(true)"
            >
              Confirm
            </button>
          </div>
        </Card>
      </Modal>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import Card from "@/components/Card";
import accordionPaySetTables from "./accordionPaySetTables";
import otherBenefits from "./otherBenefits";
import employeeReliefs from "./Reliefs/index";

export default {
  components: {
    Modal,
    Card,
    accordionPaySetTables,
    employeeReliefs,
    otherBenefits,
    SwitchToggle: () => import('@/components/Switch'),
    ToolTip: () => import('@/components/ToolTip'),
  },
  props: {
    employeeDetails: {
      type: Object,
      default: () => { },
    },
    otherBenefitData: {
      type: Array,
      default() {
        return [];
      }
    },
  },
  data() {
    return {
      authText: '',
      type: '',
      isNfhNhisModal: false,
      IsNHISToolTip: false,
      IsNHFToolTip: false,
      loadingPage: false,
      isLoadingReliefs: false,
      payType: 'salaried',
      payFrequency: null,
      paySetting: '',
      enabledNHF: false,
      enabledNhis: false,
      enabledPAYE: false,
      enabledPension: false,
      enabledWHT: false,
      employeeEarnings: [],
      employeeDeductions: [],
      employeeReliefs: [],
      employeeReliefsHistorys: [],
      allowGeneralPaySettingsOverride: false,
      employmentType: '',
      paySettingsName:'',
      isSaving: false,
      employeeId: ''
    };
  },
  computed: {
    isBasic() {
      return (
        this.$store.state.subscription &&
        this.$store.state.subscription.plan === "basic"
      );
    },
  },
  methods: {
    onEnter(value){
      if (value === 'nhf') {
        this.IsNHFToolTip = true;
        return
      }
      if (value === 'nhis') {
        this.IsNHISToolTip = true;
      }
    },
    onLeave(value){
       if (value === 'nhf') {
        this.IsNHFToolTip = false;
        return
      }
      if (value === 'nhis') {
        this.IsNHISToolTip = false;
      }
    },
    changeNhfNhisStatutory(type) {
      this.isNfhNhisModal = true;
      if(type === 'nhf'){
        this.type = 'nhf';
        this.authText = `You’re about to opt out of the National Housing Fund (NHF). 
          Future deductions will stop immediately after confirmation.`
      }
      if(type === 'nhis'){
        this.type = 'nhis';
        this.authText = `You’re about to opt out of the National Health Insurance Scheme (NHIS). 
          Future deductions will stop immediately after confirmation.`
      }
    },
    optOutNhfNhis(value){
      if(value){
        this.toggleStatutory(this.type)
      }
      if(!value){
        this.isNfhNhisModal = false;
      }
    },
    toggleStatutory(type) {
      this.isNfhNhisModal = false;
      switch (type) {
        case 'nhf':
          this.enabledNHF = !this.enabledNHF;
          this.$toasted.success(`Successfully opt out of ${type}`, { duration: 5000 });
          break;
        case 'nhis':
          this.enabledNhis = !this.enabledNhis;
          this.$toasted.success(`Successfully opt out of ${type}`, { duration: 5000 });
          break;
        default:
          break;
      }
    },
    async refresh(){
        await this.getEmployeePaysettings();
    },
    async getEmployeePaysettings() {
      this.loadingPage = true;
      try {
        const result = await this.$_getEmployeePaySettings({employeeId: this.employeeDetails.id });
        this.employmentType = result.data.employee.employmentType;
        this.paySettingsName = result.data.paysetting.name;
        const { payType, payFrequency } = this.employeeDetails;
        this.payType = payType || "salaried";
        this.payFrequency = this.getSlug(payFrequency);
        this.enabledNHF = result.data.employee.enabledNHF;
        this.enabledNhis = result.data.employee.enabledNhis;
        this.enabledPAYE = result.data.employee.enabledPAYE;
        this.enabledPension = result.data.employee.enabledPension;
        this.enabledWHT = result.data.employee.enabledWHT;
        this.employeeEarnings = result.data?.earnings;
        this.employeeDeductions = result.data?.deductions;
        this.employeeId = this.employeeDetails.id;
        this.allowGeneralPaySettingsOverride = result.data.employee.allowGeneralPaySettingsOverride || false;
        await this.getEmployeeReliefs();
        this.loadingPage = false;
      } catch (error) {
        this.loadingPage = false;
      }
    },
    getSlug(name) {
      if (name === "weekly") return "Four Times Monthly";
      if (name === "monthly") return "Monthly";
      if (name === "twice_monthly") return "Twice Monthly";
      return "";
    },
    async getEmployeeReliefs() {
      this.isLoadingReliefs = true;

      const current = await this.$_getEmployeeReliefs(
        { employeeId: this.employeeDetails.userId },
        'latest'
      );
      this.employeeReliefs = current.data.data;
      const history = await this.$_getEmployeeReliefs(
        { employeeId: this.employeeDetails.userId },
        'history'
      );
      this.employeeReliefsHistorys = history.data.data;
      this.isLoadingReliefs = false;
    },
    async savePaySettingChanges(){
      this.isSaving = true;
      const combinedEarningsDeductions = [...(this.employeeEarnings || []), ...(this.employeeDeductions || [])];
      const employeeSettings = combinedEarningsDeductions.map(item => {
          if (!item.employeeSetting) return null;
          const { employeeId, paySettingId, rateValue } = item.employeeSetting;
          return { employeeId, paySettingId, rateValue };
      }).filter(Boolean);
      const payload = {
        paysettings: [
           ...employeeSettings
        ],
        employeeId: this.employeeId,
        enabledNHF: this.enabledNHF,
        enabledNhis: this.enabledNhis,
        enabledPension: this.enabledPension,
        enabledPAYE: this.enabledPAYE,
        enabledWHT: this.enabledWHT,
        allowGeneralPaySettingsOverride: this.allowGeneralPaySettingsOverride,
        payType: this.payType,
        payFrequency: this.payFrequency,
      }
      try {
        await this.$_patchEmployeePaySettings(payload);
        this.isSaving = false;
        await this.getEmployeePaysettings();
        this.$toasted.success("Employee Pay setting updated successfully", { duration: 5000 });
      } catch (error) {
        this.isSaving = false;
        this.$toasted.error("Error updating employee pay setting", { duration: 5000 });
      }
    }
  },
  async mounted() {
    await this.getEmployeePaysettings();
  },
};
</script>
<style scoped>
.bg-color{
  border: 1px solid #E993235C;
  background: #E9932314;
}
.m-top{
  margin-top: 6px;
}
.tooltip__header{
    min-height: 17px;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.035em;
    border-bottom: 0.5px dashed #FFFFFF;
    margin: 4px 0px;
}
.line{
  border: 0.5px solid #00000029;
  width: 100%;
  height: 0;
  margin-top: 15px;
  margin-bottom: 5px;
  border-radius: 10px;
  padding: 0;
}
</style>
